import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';

import { lang } from '@lang';
import { useContext, type JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext, DesignActionTypes, useDeleteDesign } from '@context';
import { useAppToast } from '@hooks';
import { selectDeleteCustomerBlueprintModal, selectNavigation, setContextPanelIsOpen, setDeleteCustomerBlueprintModal, useAppDispatch, useAppSelector } from '@state';

export const DeleteCustomerBlueprintModal = (): JSX.Element => {
	const dispatch = useAppDispatch();
	const state = useAppSelector(selectDeleteCustomerBlueprintModal);
	const appNav = useAppSelector(selectNavigation);
	const deleteBp = useDeleteDesign({ appNav });
	const appToast = useAppToast();

	const { appDispatch, appState: { customerDesigns: designs }} = useContext(AppContext);

	const onClose = () => {
		dispatch(setDeleteCustomerBlueprintModal({ isOpen: false, data: null }));
	};

	const handleDelete = async (): Promise<void> => {
		const designId = state.data;
		if (!designId) {
			dispatch(setDeleteCustomerBlueprintModal({ isOpen: false, data: null }));
			return;
		}

		const success = await deleteBp(designId);
		if (!success) {
			appToast.error({ title: lang.customer.message.deleteCustomerBlueprintFailed });
			return;
		}

		appDispatch({ type: DesignActionTypes.deleteBlueprint, payload: designId });
		dispatch(setDeleteCustomerBlueprintModal({ isOpen: false, data: null }));
		dispatch(setContextPanelIsOpen(false));
	};

	return (
		<Modal isOpen={state.isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalCloseButton />
				<>
					<ModalHeader>Warning</ModalHeader>
					<ModalBody>
						<Text>{lang.customer.message.deleteCustomerBlueprintWarning}</Text>
					</ModalBody>

					<ModalFooter>
						<Button variant="ghost" mr={3} onClick={onClose}>Cancel</Button>
						<Button colorScheme="green" onClick={handleDelete}>Continue</Button>
					</ModalFooter>
				</>
			</ModalContent>
		</Modal>
	);
};
